// Doubtful Players — availability list (Phase 3).
//
// Emits the SAME DOM + class names as the legacy renderDoubtfulPlayersModule, so
// the shared CSS renders it identically (verified by the visual A/B test). Data
// comes from app-api via `useWidgetData`; the team control stays a
// legacy shell select and its value arrives through the bridge context (`team`,
// defaulting to "Arsenal", matching the legacy `teamVal || 'Arsenal'`).
//
// Every player gets the same fixed "DOUBTFUL" badge (amber) — its inline style
// is a literal, not data-derived, but the legacy renderer emits it inline so we
// match it exactly to stay pixel-identical.

import { EMPTY_DOUBTFUL } from "@bento/shared";
import { useWidgetData } from "../../data/useWidgetData.js";
import { useFixtureKey } from "../../data/useFixtureKey.js";
import WidgetSkeleton from "./WidgetSkeleton.js";
import WidgetError from "./WidgetError.js";

export interface DoubtfulPlayersProps {
  /** Active fixture label; slugified for the endpoint. */
  fixture: string;
  /** Selected team (full name), from the team-toggle; falls back to Arsenal. */
  team?: string | null;
}

export default function DoubtfulPlayers({ fixture, team }: DoubtfulPlayersProps) {
  const selected = team || "Arsenal";
  const {
    data: doubtful,
    isPending,
    isError,
    refetch,
  } = useWidgetData("doubtful-players", useFixtureKey(fixture));

  if (isPending) return <WidgetSkeleton />;
  if (isError) return <WidgetError onRetry={refetch} />;

  const data = doubtful[selected] ?? EMPTY_DOUBTFUL;

  return (
    <div className="data-wrapper top-align">
      <div className="bm-updated">Updated: {data.updated}</div>
      {data.players.length ? (
        data.players.map((p, i) => (
          <div className="data-row" key={`${p.name}-${i}`}>
            <div className="col-team">{p.name}</div>
            <span
              className="inj-badge"
              style={{
                background: "#f39c1222",
                color: "#f39c12",
                border: "1px solid #f39c1244",
              }}
            >
              DOUBTFUL
            </span>
          </div>
        ))
      ) : (
        <div className="bm-empty">No doubtful players reported.</div>
      )}
    </div>
  );
}
